import { onApiError } from "../error";
import { del, get, post, put } from "./client";

/**
 * @param {string} imsi
 */
async function delFarmcamSim(imsi) {
	const res = await del(`/farmcam-sims/${imsi}`);
	if (!res.ok) throw await onApiError(res);
}

/**
 * @param {string} imsi
 * @returns {Promise<FarmcamSim>}
 */
async function getFarmcamSim(imsi) {
	const res = await get(`/farmcam-sims/${imsi}`);

	if (!res.ok) throw await onApiError(res);
	return res.json();
}

/**
 * @typedef {Object} RemainingDataDataPoint
 * @property {string} Imsi
 * @property {number} RemainingData
 * @property {string} Timestamp
 */

/**
 * @param {string} imsi
 * @param {DataPointQueryParams} [args]
 * @returns {Promise<RemainingDataDataPoint[]|Blob>}
 */
async function getFarmcamSimRemainingData(imsi, args) {
	const queryString = [
		args?.from ? `from=${args.from}` : "",
		args?.to ? `to=${args.to}` : "",
		args?.format ? `format=${args.format}` : "",
	];

	let path = `/farmcam-sims/${imsi}/remaining-data`;
	if (queryString.length > 0) {
		path += `?${queryString}`;
	}

	const res = await get(path);
	if (!res.ok) throw await onApiError(res);
	if (args?.format === "json") return res.json();
	return res.blob();
}

/**
 * @param {string} imsi
 * @returns {Promise<FarmcamSim>}
 */
async function postFarmcamSimData(imsi) {
	const res = await post(`/farmcam-sims/${imsi}/data`);

	if (!res.ok) throw await onApiError(res);
	return res.json();
}

/**
 * @param {string} imsi
 * @param {PutFarmcamSimParams} args
 * @returns {Promise<FarmcamSim>}
 */
async function putFarmcamSim(imsi, args) {
	const res = await put(`/farmcam-sims/${imsi}`, {
		body: JSON.stringify(args),
	});

	if (!res.ok) throw await onApiError(res);
	return res.json();
}

export {
	delFarmcamSim,
	getFarmcamSim,
	getFarmcamSimRemainingData,
	postFarmcamSimData,
	putFarmcamSim,
};
